export enum FrequencyType {
  DAILY_SINGLE_PAY = 'DAILY_SINGLE_PAY',
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
  ANNUAL = 'ANNUAL'
}
